import {
  array as yupArray,
  mixed as yupMixed,
  object as yupObject,
  string as yupString,
} from 'yup'

import { isFunction } from './utils'

const baseValidations = {
  repositoryName: yupString()
    .strict()
    .required(),
  accessToken: yupString()
    .strict()
    .required(),
  linkResolver: yupMixed()
    .test('is function', '${path} is not a function', isFunction)
    .default(() => () => () => {}),
  fetchLinks: yupArray()
    .of(
      yupString()
        .strict()
        .required(),
    )
    .default([]),
  htmlSerializer: yupMixed()
    .test('is function', '${path} is not a function', isFunction)
    .default(() => () => () => {}),
  schemas: yupObject()
    .strict()
    .required(),
  lang: yupString().default('*'),
  shouldDownloadImage: yupMixed()
    .test('is function', '${path} is not a function', isFunction)
    .default(() => () => false),
  // TODO: Remove `shouldNormalizeImage` in version 4
  shouldNormalizeImage: yupMixed().test(
    'is function',
    '${path} is not a function',
    x => typeof x === 'undefined' || isFunction(x),
  ),
  plugins: yupArray()
    .max(0)
    .default([]),
  // Default value set in validatePluginOptions below.
  typePathsFilenamePrefix: yupString().default(`prismic-typepaths---`),

  // Browser-only validations
  pathResolver: yupMixed().test(
    'is function',
    '${path} is not a function',
    x => typeof x === 'undefined' || isFunction(x),
  ),
  schemasDigest: yupString()
    .strict()
    .required(),
}

export const validatePluginOptions = (
  pluginOptions,
  filterValidations = {},
) => {
  // Must do this here with access to pluginOptions.
  if (pluginOptions.repositoryName)
    baseValidations.typePathsFilenamePrefix = baseValidations.typePathsFilenamePrefix.default(
      `prismic-typepaths---${pluginOptions.repositoryName &&
        pluginOptions.repositoryName.toString()}-`,
    )

  // Filter validations based on the filterValidations param.
  const filteredValidations = Object.keys(baseValidations).reduce(
    (acc, key) => {
      if (filterValidations[key] || !filterValidations.hasOwnProperty(key))
        acc[key] = baseValidations[key]
      return acc
    },
    {},
  )

  const schema = yupObject().shape(filteredValidations)

  return schema.validateSync(pluginOptions, { abortEarly: false })
}
